var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"weui-btn-area"},[_c('button',{staticClass:"weui-btn weui-btn_primary",on:{"click":_vm.toScan}},[_vm._v("扫描二维码")])])])}
var staticRenderFns = []

export { render, staticRenderFns }